"use strict";
var Ps = require('perfect-scrollbar');
var core_1 = require('@angular/core');
var perfect_scrollbar_interfaces_1 = require('./perfect-scrollbar.interfaces');
var PerfectScrollbarComponent = (function () {
    function PerfectScrollbarComponent(elementRef, defaults, zone) {
        this.elementRef = elementRef;
        this.defaults = defaults;
        this.zone = zone;
        this.runInsideAngular = false;
    }
    PerfectScrollbarComponent.prototype.ngDoCheck = function () {
        if (this.elementRef.nativeElement.children && this.elementRef.nativeElement.children.length) {
            var width = this.elementRef.nativeElement.offsetWidth;
            var height = this.elementRef.nativeElement.offsetHeight;
            var contentWidth = this.elementRef.nativeElement.children[0].offsetWidth;
            var contentHeight = this.elementRef.nativeElement.children[0].offsetHeight;
            if (width !== this.width || height !== this.height || contentWidth !== this.contentWidth || contentHeight !== this.contentHeight) {
                this.width = width;
                this.height = height;
                this.contentWidth = contentWidth;
                this.contentHeight = contentHeight;
                this.update();
            }
        }
    };
    PerfectScrollbarComponent.prototype.ngOnDestroy = function () {
        var _this = this;
        if (this.runInsideAngular) {
            Ps.destroy(this.elementRef.nativeElement);
        }
        else {
            this.zone.runOutsideAngular(function () {
                Ps.destroy(_this.elementRef.nativeElement);
            });
        }
    };
    PerfectScrollbarComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var config = new perfect_scrollbar_interfaces_1.PerfectScrollbarConfig(this.defaults);
        config.assign(this.config);
        if (this.runInsideAngular) {
            Ps.initialize(this.elementRef.nativeElement, config);
        }
        else {
            this.zone.runOutsideAngular(function () {
                Ps.initialize(_this.elementRef.nativeElement, config);
            });
        }
    };
    PerfectScrollbarComponent.prototype.update = function () {
        var _this = this;
        if (this.runInsideAngular) {
            Ps.update(this.elementRef.nativeElement);
        }
        else {
            this.zone.runOutsideAngular(function () {
                Ps.update(_this.elementRef.nativeElement);
            });
        }
    };
    PerfectScrollbarComponent.prototype.scrollTo = function (x, y) {
        if (y == null) {
            this.elementRef.nativeElement.scrollTop = x;
        }
        else {
            this.elementRef.nativeElement.scrollTop = y;
            this.elementRef.nativeElement.scrollLeft = x;
        }
        this.update();
    };
    PerfectScrollbarComponent.prototype.scrollToTop = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.elementRef.nativeElement.scrollTop = 0 + offset;
        this.update();
    };
    PerfectScrollbarComponent.prototype.scrollToLeft = function (offset) {
        if (offset === void 0) { offset = 0; }
        this.elementRef.nativeElement.scrollLeft = 0 + offset;
        this.update();
    };
    PerfectScrollbarComponent.prototype.scrollToRight = function (offset) {
        if (offset === void 0) { offset = 0; }
        var width = this.elementRef.nativeElement.scrollWidth;
        this.elementRef.nativeElement.scrollLeft = width - offset;
        this.update();
    };
    PerfectScrollbarComponent.prototype.scrollToBottom = function (offset) {
        if (offset === void 0) { offset = 0; }
        var height = this.elementRef.nativeElement.scrollHeight;
        this.elementRef.nativeElement.scrollTop = height - offset;
        this.update();
    };
    PerfectScrollbarComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'perfect-scrollbar',
                    template: '<div class="ps-content"><ng-content></ng-content></div>',
                    styles: ['.ps-container{-ms-touch-action:auto;touch-action:auto;overflow:hidden!important;-ms-overflow-style:none}@supports (-ms-overflow-style:none){.ps-container{overflow:auto!important}}@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){.ps-container{overflow:auto!important}}.ps-container.ps-active-x>.ps-scrollbar-x-rail,.ps-container.ps-active-y>.ps-scrollbar-y-rail{display:block;background-color:transparent}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container>.ps-scrollbar-x-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;bottom:0;height:15px}.ps-container>.ps-scrollbar-x-rail>.ps-scrollbar-x{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;bottom:2px;height:6px}.ps-container>.ps-scrollbar-x-rail:active>.ps-scrollbar-x,.ps-container>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{height:11px}.ps-container>.ps-scrollbar-y-rail{display:none;position:absolute;opacity:0;-webkit-transition:background-color .2s linear,opacity .2s linear;-o-transition:background-color .2s linear,opacity .2s linear;-moz-transition:background-color .2s linear,opacity .2s linear;transition:background-color .2s linear,opacity .2s linear;right:0;width:15px}.ps-container>.ps-scrollbar-y-rail>.ps-scrollbar-y{position:absolute;background-color:#aaa;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px;-webkit-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,-webkit-border-radius .2s ease-in-out;-o-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;-moz-transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out;transition:background-color .2s linear,height .2s linear,width .2s ease-in-out,border-radius .2s ease-in-out,-webkit-border-radius .2s ease-in-out,-moz-border-radius .2s ease-in-out;right:2px;width:6px}.ps-container>.ps-scrollbar-y-rail:active>.ps-scrollbar-y,.ps-container>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{width:11px}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-x>.ps-scrollbar-x-rail>.ps-scrollbar-x{background-color:#999;height:11px}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail{background-color:#eee;opacity:.9}.ps-container:hover.ps-in-scrolling.ps-y>.ps-scrollbar-y-rail>.ps-scrollbar-y{background-color:#999;width:11px}.ps-container:hover>.ps-scrollbar-x-rail,.ps-container:hover>.ps-scrollbar-y-rail{opacity:.6}.ps-container:hover>.ps-scrollbar-x-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-x-rail:hover>.ps-scrollbar-x{background-color:#999}.ps-container:hover>.ps-scrollbar-y-rail:hover{background-color:#eee;opacity:.9}.ps-container:hover>.ps-scrollbar-y-rail:hover>.ps-scrollbar-y{background-color:#999}.ps-container{position:relative;display:block}.ps-container .ps-content{min-height:100%}.ps-container[hidden]{display:none}.ps-container[fxlayout]>.ps-content{display:flex}'],
                    encapsulation: core_1.ViewEncapsulation.None
                },] },
    ];
    /** @nocollapse */
    PerfectScrollbarComponent.ctorParameters = function () { return [
        { type: core_1.ElementRef, },
        { type: perfect_scrollbar_interfaces_1.PerfectScrollbarConfig, decorators: [{ type: core_1.Optional },] },
        { type: core_1.NgZone, },
    ]; };
    PerfectScrollbarComponent.propDecorators = {
        'runInsideAngular': [{ type: core_1.Input },],
        'config': [{ type: core_1.Input },],
    };
    return PerfectScrollbarComponent;
}());
exports.PerfectScrollbarComponent = PerfectScrollbarComponent;
//# sourceMappingURL=perfect-scrollbar.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-perfect-scrollbar/dist/lib/perfect-scrollbar.component.js
// module id = 688
// module chunks = 4